import { login as loginUser } from "../../../../services/identity";
import { IDENTITY_SDK_FAILURE } from "../constants";
import { SdkError, LoggedError } from "../../../../services/errors";

export const login = () => dispatch => {
  try {
    loginUser();
  } catch (e) {
    if (e instanceof SdkError) {
      return dispatch({ type: IDENTITY_SDK_FAILURE });
    }
    throw new LoggedError(e, LoggedError.error);
  }
};
